import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Client from '@spike/client-model';
import { RootState } from 'store';

// The drawer loads the client on the search step, so the status never changes again once
// the form mounts. Fills once per client: otherwise clearing the field refills it.
export const useClientAddressPrefill = (
    clientId: number,
    enabled: boolean,
    address: string | undefined,
    onPrefill: (address: string) => void
): void => {
    const client = useSelector<RootState, Client | undefined>(state => state.clients.client);
    const prefilledAddressForRef = useRef<number | undefined>(undefined);

    useEffect(() => {
        if (!enabled) return;
        if (Number(client?.id) !== Number(clientId)) return;
        if (prefilledAddressForRef.current === clientId) return;

        if (address?.trim()) {
            prefilledAddressForRef.current = clientId;
            return;
        }

        const line = [client?.address?.street, client?.address?.city, client?.address?.state, client?.address?.zipcode]
            .filter(part => part && part.trim() !== '')
            .join(', ');

        if (line === '') return;

        prefilledAddressForRef.current = clientId;
        onPrefill(line);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client, clientId, enabled, address]);
};

export default useClientAddressPrefill;
